import React from 'react';
import { Box } from '@mui/material';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';

interface LeagueLogoProps {
  leagueId?: string; // Keep for backward compatibility
  leagueName: string;
  size?: number;
  logoPath?: string;
  logoUrl?: string;
  onLoad?: () => void;
  style?: React.CSSProperties;
}

export const LeagueLogo: React.FC<LeagueLogoProps> = React.memo(({
  leagueName,
  size = 32,
  logoPath,
  logoUrl,
  onLoad,
  style
}) => {
  const [error, setError] = React.useState(false);

  // Reset error state when logo props change
  React.useEffect(() => {
    setError(false);
  }, [logoPath, logoUrl]);

  // Determine logo source - prefer logoPath (downloaded) over logoUrl
  const logoSrc = logoPath ? `/${logoPath}` : logoUrl;

  if (!logoSrc || error) {
    return (
      <Box
        sx={{
          width: size,
          height: size,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: 'grey.300',
          borderRadius: 1
        }}
      >
        <EmojiEventsIcon sx={{ fontSize: size * 0.6 }} />
      </Box>
    );
  }

  return (
    <Box
      component="img"
      src={logoSrc}
      alt={leagueName}
      sx={{
        maxWidth: size,
        maxHeight: size,
        width: 'auto',
        height: 'auto',
        objectFit: 'contain',
        ...style
      }}
      onError={() => setError(true)}
      onLoad={onLoad}
    />
  );
});

export default LeagueLogo;
